const colors = {
  quickBar: "#151C28",
  buttonBGColor: "#333333",
  countersBGColor: "#E2E8F0",
  breadcrumbActiveColor: "#ED1C24",
  breadCrumbMenuColor: "#333333",
  progressColor: "#00B207",
  progressColorInactive: "#F2F2F2",
  buttonOutlinedBorderColor: "#000000",
  headerTextColor: "#2E2A40",
  defaultFontColor: "#253642",
  linkColor: "#669BBC",
  textColor2: "#333333",
  background2: "#FFFFFF",
  greyTextColor: "#9699A0",
  lightGrey: "#F4F6FA",
};

export default colors;
